/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAddressesRequest
 */
export interface FindAddressesRequest {
    /**
     * 
     * @type {string}
     * @memberof FindAddressesRequest
     */
    searchstring: string;
}

export function FindAddressesRequestFromJSON(json: any): FindAddressesRequest {
    return FindAddressesRequestFromJSONTyped(json, false);
}

export function FindAddressesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAddressesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchstring': json['searchstring'],
    };
}

export function FindAddressesRequestToJSON(value?: FindAddressesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchstring': value.searchstring,
    };
}


